import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConfused = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 677 677",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #00b6e0;\n      }\n\n      .st2 {\n        fill: #0075c7;\n      }\n\n      .st3 {\n        fill: #003343;\n      }\n\n      .st4 {\n        mix-blend-mode: multiply;\n        opacity: .17;\n      }\n\n      .st5 {\n        fill: #73ccf4;\n      }\n\n      .st6 {\n        fill: #ffba40;\n      }\n\n      .st7 {\n        fill: #f48d2e;\n      }\n\n      .st8 {\n        isolation: isolate;\n      }\n\n      .st9 {\n        fill: #fff;\n      }\n\n      .st10 {\n        opacity: .32;\n      }\n\n      .st11 {\n        opacity: .11;\n      }\n\n      .st12 {\n        fill: #bbe5ff;\n      }\n\n      .st13 {\n        fill: #282828;\n      }\n\n      .st14 {\n        fill: #003f99;\n      }\n\n      .st15 {\n        clip-path: url(#clippath);\n      }\n    " }), /* @__PURE__ */ _jsx("clipPath", {
			id: "clippath",
			children: /* @__PURE__ */ _jsx("path", {
				className: "st0",
				d: "M296.4375,194.882c-7.9617,21.06-26.7519,33.0065-41.969,26.6834-15.2171-6.3231-21.0988-28.5215-13.1371-49.5815,7.9617-21.06,26.7519-33.0065,41.969-26.6834,15.2171,6.3231,21.0988,28.5215,13.1371,49.5815Z"
			})
		})] }),
		/* @__PURE__ */ _jsx("g", {
			className: "st8",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Layer_1",
				children: /* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("g", {
						className: "st11",
						children: /* @__PURE__ */ _jsx("ellipse", {
							className: "st14",
							cx: 357.2666,
							cy: 506.1322,
							rx: 172.3998,
							ry: 24.7892
						})
					}),
					/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "st5",
							d: "M273.3865,387.4086c-22.2464-41.3968-18.7048-85.3501-12.6418-114.9024,1.0789-5.2889,2.2399-10.1088,3.3422-14.3775,0,0,8.1738-17.7549,24.7325-34.3136,16.547-16.547,17.4382-36.014,0-40.0012-8.6077-1.9702-56.6069,4.3742-56.6069,4.3742,0,0-9.4873,2.7324-12.5129,2.7911,1.3955-9.9915,3.7996-20.4521,7.5875-31.0769,8.7015-24.4393,57.205-80.6944,136.0934-77.6923,78.8884,3.0139,117.7404,34.1142,136.4921,90.5921,17.8722,53.8393-5.5469,80.2019-5.5469,80.2019,0,0,48.5151,71.301,50.9192,120.0741,2.4158,48.7731,17.4617,115.6178,27.6995,130.6754,10.2378,15.0576-55.9971-7.822-68.0408-14.4478-4.4211,1.4424-10.5896,2.9083-17.9894,4.3508h-.0117c-17.0747,3.3422-40.6462,6.5437-64.0888,8.9126-30.127,3.0491-60.0312,4.7378-75.6869,3.6002-4.8316-.3518-10.3551-.8795-16.3007-1.6418-.3753-.0586-.7623-.1055-1.1493-.1407-4.5032-.5864-9.2293-1.29-14.0843-2.1461l.0352-.1759c-16.8753-17.5203-44.6569-61.8958-42.2411-114.6562Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st7",
							d: "M486.9141,493.6564c7.0949,4.3859,25.2368,23.6067-.0117,23.0673-25.2485-.5277-64.0888-14.1546-64.0888-14.1546,23.4425-2.3689,47.0141-5.5704,64.0888-8.9126h.0117Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st7",
							d: "M330.826,504.5275c16.8988,2.3923,29.6696,18.9041-6.0512,18.2357-36.53-.6802-23.3487-11.8913-50.8019-8.2559-27.4532,3.6354-51.7401,5.9574-28.0161-9.628-14.5299-7.9393-18.8572-21.4372,8.725-23.5364,16.2186,10.6834,39.6846,17.1568,60.9107,20.8978,4.855.8561,9.5811,1.5597,14.0843,2.1461.387.0352.774.0821,1.1493.1407Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st12",
							d: "M315.6276,502.0648l-.0352.1759c-21.2261-3.741-44.6921-10.2143-60.9107-20.8978-8.6781-5.7111-15.2805-12.6184-18.3647-20.9447-12.0438-32.5193-26.4916-136.0934-8.4318-187.8921h32.8594c-6.0629,29.5524-9.6045,73.5057,12.6418,114.9024-2.4158,52.7604,25.3658,97.1358,42.2411,114.6562Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st6",
							d: "M288.8194,183.8139c17.4382,3.9872,16.547,23.4543,0,40.0012-16.5587,16.5587-24.7325,34.3136-24.7325,34.3136-1.1024,4.2687-2.2633,9.0885-3.3422,14.3775h-.0117c-37.4447-17.8252-33.3402-1.6418-32.8829-.1173-.903-2.2751-14.2954-37.4213-8.1504-81.4098,3.0256-.0586,12.5129-2.7911,12.5129-2.7911,0,0,47.9992-6.3444,56.6069-4.3742Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st12",
							d: "M260.7329,272.5062h-32.8477s-.0117-.0352-.0352-.1173c-.4574-1.5245-4.5619-17.708,32.8829.1173Z"
						})
					] }), /* @__PURE__ */ _jsx("path", {
						className: "st1",
						d: "M377.2095,479.0766c-8.4076.0012-30.2854-7.1686-79.9982-57.5009-9.3556-9.4782-17.2802-19.9183-23.5527-31.0293-.3466-.6141-.1304-1.3936.4843-1.7402.6123-.3466,1.3936-.1298,1.7402.4843,6.1614,10.9147,13.9495,21.1731,23.1458,30.4907,45.9329,46.5047,72.163,59.4332,80.6684,56.3917,1.983-.7107,3.0614-2.3139,3.2981-4.9018,1.0676-11.7957-35.3466-86.9512-54.7499-125.0428-.32-.6286-.07-1.3972.5579-1.7179.6304-.3194,1.3997-.0688,1.7173.5585,2.3042,4.5232,56.4177,110.9635,55.018,126.4334-.413,4.5208-2.9358,6.3426-4.9803,7.075-.7234.2596-1.8127.4994-3.3488.4994Z"
					})] }),
					/* @__PURE__ */ _jsx("path", {
						className: "st5",
						d: "M231.0138,333.8721v26.2452s2.0018,14.4091,14.3525,14.4091,15.5182-15.0477,15.5182-15.0477c0,0-5.1052-21.0264-4.9455-25.6067h-24.9253Z"
					}),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
							className: "st9",
							d: "M283.2884,145.302c15.2316,6.3292,21.1084,28.5204,13.1507,49.5779-7.9738,21.0558-26.7661,33.0118-41.9815,26.6842-7.778-3.2493-13.119-10.6192-15.414-19.8901,2.5864,6.4255,7.2339,10.8484,13.2771,11.7235,11.8443,1.7253,24.5277-10.8017,28.3412-27.9534s-2.6941-32.4522-14.5223-34.1758c-5.8656-.8568-11.9298,1.7826-17.022,6.7565,9.3549-11.9373,22.7678-17.4723,34.1708-12.7227Z"
						}), /* @__PURE__ */ _jsx("path", {
							className: "st13",
							d: "M266.1396,151.2683c11.8282,1.7236,18.3358,17.0242,14.5223,34.1758s-16.4969,29.6787-28.3412,27.9534c-6.0432-.8751-10.6908-5.298-13.2771-11.7235-2.1954-8.8333-1.6078-19.4005,2.2794-29.6861,1.9905-5.274,4.6695-9.9719,7.7946-13.9632,5.0922-4.9739,11.1564-7.6133,17.022-6.7565Z"
						})] }),
						/* @__PURE__ */ _jsx("g", {
							className: "st15",
							children: /* @__PURE__ */ _jsx("g", {
								className: "st4",
								children: /* @__PURE__ */ _jsx("path", {
									className: "st3",
									d: "M238.7923,173.4267s5.2009-10.6942,27.4717.3682c19.9438,9.9066,30.704,33.0504,30.704,33.0504,0,0,18.6301-48.3806-10.7921-63.1913-31.8669-16.0413-47.3836,29.7726-47.3836,29.7726Z"
								})
							})
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st9",
							d: "M259.2749,170.7601c-2.9441,4.715-7.1353,6.9968-9.3613,5.0967-2.226-1.9002-1.6439-7.2628,1.3002-11.9778,2.9441-4.715,7.1353-6.9968,9.3613-5.0967,2.226,1.9002,1.6439,7.2628-1.3002,11.9778Z"
						})
					] }),
					/* @__PURE__ */ _jsx("path", { d: "M228.3922,183.5496c9.5563,0,10.8443,7.5067,8.1436,37.0389,0,0-.1662-4.8097-17.3259-5.2142-17.1597-.3596-40.5518-10.833-40.5518-10.833-10.3041.5844-23.2259.3147-9.9718-8.2708,14.2929-9.2597,27.9209-12.7658,59.7059-12.7209Z" }),
					/* @__PURE__ */ _jsx("path", { d: "M311.2611,141.4353c-.436,0-.878-.1129-1.2801-.3508-18.2077-10.7384-18.5519-27.6557-18.2222-32.5847.093-1.3918,1.3043-2.4328,2.687-2.3519,1.3912.093,2.4443,1.2964,2.3513,2.6876-.3587,5.3843.4577,18.8804,15.7489,27.8991,1.2016.7083,1.6013,2.2565.8925,3.4581-.471.7983-1.3127,1.2427-2.1774,1.2427Z" }),
					/* @__PURE__ */ _jsxs("g", { children: [
						/* @__PURE__ */ _jsx("path", {
							className: "st2",
							d: "M296.6023,132.3826c-.1152,0-.2312-.0109-.3472-.0331l-32.1536-6.1338c-.7277-.1388-1.3764-.7005-1.8267-1.5819-.45-.8812-.6477-1.9764-.5564-3.0839l2.1669-26.3017c.1882-2.2859,1.5603-3.9139,3.0662-3.6264l32.1536,6.1339c.7279.1388,1.3764.7006,1.8267,1.5819.45.8812.6477,1.9764.5564,3.0839l-2.1669,26.3017c-.0913,1.1075-.4602,2.0947-1.0394,2.7795-.4868.5756-1.073.8799-1.6795.8799ZM266.6097,95.4135c-.1155,0-.2162.1313-.2309.3103l-2.1669,26.3017c-.0137.1658.0932.375.2022.3957l32.1536,6.1338c.1096.0216.2465-.1419.2602-.3075l2.1669-26.3017c.0137-.1658-.0932-.375-.2022-.3957l-32.1536-6.1339c-.0099-.0018-.0196-.0028-.0293-.0028Z"
						}),
						/* @__PURE__ */ _jsx("path", {
							className: "st2",
							d: "M296.6023,132.3826c-.1152,0-.2312-.0109-.3472-.0331l-32.1536-6.1338c-.7277-.1388-1.3764-.7005-1.8267-1.5819-.45-.8812-.6477-1.9764-.5564-3.0839l2.1669-26.3017c.1882-2.2859,1.5603-3.9139,3.0662-3.6264l32.1536,6.1339c.7279.1388,1.3764.7006,1.8267,1.5819.45.8812.6477,1.9764.5564,3.0839l-2.1669,26.3017c-.0913,1.1075-.4602,2.0947-1.0394,2.7795-.4868.5756-1.073.8799-1.6795.8799ZM266.6097,95.4135c-.1155,0-.2162.1313-.2309.3103l-2.1669,26.3017c-.0137.1658.0932.375.2022.3957l32.1536,6.1338c.1096.0216.2465-.1419.2602-.3075l2.1669-26.3017c.0137-.1658-.0932-.375-.2022-.3957l-32.1536-6.1339c-.0099-.0018-.0196-.0028-.0293-.0028Z"
						}),
						/* @__PURE__ */ _jsx("g", {
							className: "st10",
							children: /* @__PURE__ */ _jsx("path", {
								className: "st9",
								d: "M296.9974,130.5641l-33.3255-6.3573c-.4926-.094-.8419-.7778-.7801-1.5274l2.3137-28.0849c.0618-.7496.5111-1.2811,1.0038-1.1871l33.3255,6.3573c.4926.094.8419.7778.7801,1.5274l-2.3137,28.0849c-.0618.7496-.5111,1.2811-1.0038,1.1871Z"
							})
						})
					] }),
					/* @__PURE__ */ _jsx("rect", {
						className: "st2",
						x: 258.1423,
						y: 188.0765,
						width: 9.4858,
						height: 9.4858,
						transform: "translate(131.6296 -105.6097) rotate(30)"
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "st2",
						x: 243.2578,
						y: 323.3907,
						width: 4.0436,
						height: 28.5688,
						rx: .499,
						ry: .499
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "st2",
						d: "M236.6036,319.2962h7.0982c.5803,0,1.0515.4711,1.0515,1.0515v13.5137h-9.2012v-13.5137c0-.5803.4711-1.0515,1.0515-1.0515Z"
					}),
					/* @__PURE__ */ _jsx("rect", {
						className: "st2",
						x: 237.6869,
						y: 312.6704,
						width: 5.3973,
						height: 6.6258,
						rx: .5408,
						ry: .5408
					})
				] })
			})
		})
	]
});
const ForwardRef = forwardRef(SvgConfused);
export default ForwardRef;
